import type { RouteLocationNormalized, RouteLocationNormalizedLoaded } from 'vue-router'
import { i18n } from '@/i18n'
import type { MessageKey } from '@/i18n/messages'

declare module 'vue-router' {
  interface RouteMeta {
    /** ADR-010 D5: catalog key of the page title; the router hook sets `document.title` from it. */
    titleKey?: MessageKey
  }
}

/** Sets `document.title` from the route's `meta.titleKey`; routes without one keep the title. */
export function applyDocumentTitle(
  route: RouteLocationNormalized | RouteLocationNormalizedLoaded
): void {
  const key = route.meta.titleKey
  if (key !== undefined) document.title = i18n.global.t(key)
}
